import React from 'react'
import { connect } from 'react-redux'
import { withSiteData } from 'react-static'

import ClientList from '../components/ClientList'
import {deleteClient} from '../actions/clients'

const Clients = withSiteData(({clients, deleteClient}) =>
  <React.Fragment>
    <div className="row">
      <div className="col-sm-12">
        <div className="page-title-box">
          <h4 className="page-title">Kunden</h4>
          <div className="clearfix"/>
        </div>
      </div>
    </div>

    <div className="row">
      <div className="col-12">
        <ClientList clients={clients.items} deleteProduct={deleteClient} />
      </div>
    </div>
  </React.Fragment>
)

export default connect(
  state => ({
    clients: state.clients
  }),
  dispatch => ({
    deleteClient: (data) => dispatch(deleteClient(data))
  })
)(Clients)



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/Clients.js